import React from "react";
import "./textBlock.css";

const TextBlock = ({ shortTitle, title, description, textSize }) => {

    return (
        <div className={"text-block--outer text-block--text-size-" + textSize}>
            {shortTitle !== "" && (<button className="title-button title-button--secondary">{shortTitle}</button>)}
            {title !== "" && (<h3>{title}</h3>)}
            {description !== "" && (<p>{description}</p>)}
        </div>
    );
};

export default TextBlock;
